<mat-tab-group>
  <mat-tab label="Roles">
    <div class="actions actions-top">
      <button mat-raised-button class="assignment-role-add-btn" (click)="addAssignmentRole()">Add assignment role</button>
    </div>

    <div class="assignment-role-table">
      <table mat-table [dataSource]="dataSource" class="mat-elevation-z2 full-width">
        <ng-container matColumnDef="name">
          <th mat-header-cell *matHeaderCellDef>Name</th>
          <td mat-cell *matCellDef="let role">{{ role.name }}</td>
        </ng-container>

        <ng-container matColumnDef="description">
          <th mat-header-cell *matHeaderCellDef>Description</th>
          <td mat-cell *matCellDef="let role">{{ role.description }}</td>
        </ng-container>

        <ng-container matColumnDef="sharedEmail">
          <th mat-header-cell *matHeaderCellDef>Shared email</th>
          <td mat-cell *matCellDef="let role">{{ role.sharedEmail }}</td>
        </ng-container>

        <ng-container matColumnDef="type">
          <th mat-header-cell *matHeaderCellDef>Type</th>
          <td mat-cell *matCellDef="let role">{{ role.type }}</td>
        </ng-container>

        <ng-container matColumnDef="sendToAll">
          <th mat-header-cell *matHeaderCellDef>Send to all</th>
          <td mat-cell *matCellDef="let role">
            <mat-icon>{{ role.sendToAll ? 'check' : 'close' }}</mat-icon>
          </td>
        </ng-container>

        <ng-container matColumnDef="edit">
          <th mat-header-cell *matHeaderCellDef></th>
          <td mat-cell *matCellDef="let role">
            <button mat-icon-button (click)="editAssignmentRole(role)">
              <mat-icon>edit</mat-icon>
            </button>
          </td>
        </ng-container>

        <ng-container matColumnDef="delete">
          <th mat-header-cell *matHeaderCellDef></th>
          <td mat-cell *matCellDef="let role">
            <button mat-icon-button color="warn" (click)="deleteAssignmentRole(role)">
              <mat-icon>delete</mat-icon>
            </button>
          </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
      </table>
    </div>

    <div class="actions">
      <button mat-raised-button class="assignment-role-add-btn" (click)="addAssignmentRole()">Add assignment role</button>
    </div>
  </mat-tab>

  <mat-tab label="User matrix">
    <app-assignment-role-matrix></app-assignment-role-matrix>
  </mat-tab>
</mat-tab-group>
